<template>
  <div class="base-list-container" :class="containerClass">
    <div class="list-header" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    
    <div class="list-content" :style="contentStyle">
      <slot></slot>
    </div>
    
    <div class="list-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseList',
  props: {
    // 容器高度类型：'default', 'small', 'large', 'custom'
    heightType: {
      type: String,
      default: 'default'
    },
    // 自定义高度
    customHeight: {
      type: String,
      default: ''
    },
    // 是否显示滚动条
    showScrollbar: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    containerClass() {
      const classes = ['base-list-container']
      
      if (this.heightType === 'small') {
        classes.push('list-small')
      } else if (this.heightType === 'large') {
        classes.push('list-large')
      } else if (this.heightType === 'custom') {
        classes.push('list-custom')
      }
      
      if (!this.showScrollbar) {
        classes.push('no-scrollbar')
      }
      
      return classes
    },
    contentStyle() {
      if (this.customHeight) {
        return { height: this.customHeight }
      }
      return {}
    }
  }
}
</script>

<style scoped>
.base-list-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.list-header {
  padding: 16px;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
}

.list-content {
  flex: 1;
  overflow: auto;
  padding: 16px;
}

.list-footer {
  padding: 16px;
  border-top: 1px solid #e8e8e8;
  background: #fafafa;
}

/* 高度类型样式 */
.list-small .list-content {
  height: calc(100vh - 280px);
}

.list-large .list-content {
  height: calc(100vh - 180px);
}

.list-custom .list-content {
  height: auto;
}

/* 滚动条样式 */
.list-content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.list-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.list-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.no-scrollbar .list-content::-webkit-scrollbar {
  display: none;
}

/* 响应式支持 */
@media (max-height: 768px) {
  .list-small .list-content {
    height: calc(100vh - 320px);
  }
  
  .list-large .list-content {
    height: calc(100vh - 220px);
  }
}

@media (min-height: 1080px) {
  .list-small .list-content {
    height: calc(100vh - 250px);
  }
  
  .list-large .list-content {
    height: calc(100vh - 150px);
  }
}
</style>



